import { User } from "firebase/auth";

import { IUser, Organisation } from "integrations/firebase/collections";
import { FirestoreOrganisationLanguage } from "reedy-data/models";
import { TERMS_AND_CONDITIONS_VERSION } from "shared/constants";

declare global {
  interface Window {
    Meticulous?: {
      isRunningAsTest: boolean;
    };
  }
}

export const METICULOUS_AUTH_USER: User = {
  uid: "meticulous-user-id",
  email: "meticulous@chaptr.xyz",
  emailVerified: true,
  isAnonymous: false,
  displayName: "Meticulous AI",
  phoneNumber: null,
  photoURL: null,
  providerId: "firebase",
  metadata: {
    creationTime: "0",
    lastSignInTime: "0",
  },
  providerData: [],
  refreshToken: "refreshToken",
  tenantId: null,
  delete: () => Promise.resolve(),
  getIdToken: () => Promise.resolve("token"),
  getIdTokenResult: () => Promise.resolve({} as never),
  reload: () => Promise.resolve(),
  toJSON: () => ({}),
};

export const METICULOUS_ORGANISATION: Organisation = {
  id: "meticulous-organisation-id",
  name: "Meticulous",
  effectiveLanguage: FirestoreOrganisationLanguage.EN_GB,
};

export const METICULOUS_USER_DATA: IUser = {
  id: METICULOUS_AUTH_USER.uid,
  userId: METICULOUS_AUTH_USER.uid,
  email: "meticulous@chaptr.xyz",
  givenName: "Meticulous",
  familyName: "AI",
  organisation: { id: METICULOUS_ORGANISATION.id },
  settings: { acceptedTermsVersion: TERMS_AND_CONDITIONS_VERSION },
};

export const isRunningInMeticulous = () =>
  Boolean(window.Meticulous?.isRunningAsTest);
